import { Box, Text, Button, KeyboardShift } from '@betty/moonlight';
import { memo, useCallback, useRef, useState } from 'react';
import { BottomSheet, Screen } from '@betty/navigation';

import NameInput from '../../../components/ResponsibleGaming/components/NameInput/NameInput';
import BirthdayInput from '../../../components/ResponsibleGaming/components/BirthdayInput/BirthdayInput';
import { SelfExclusionSScreenProps } from './SelfExclusionVerifyScreen.types';
import { TextInput } from 'react-native';

function SelfExclusionVerifyScreen({ route }: SelfExclusionSScreenProps) {
  const selfExcludeTime = route.params.value;

  const [isNameValid, setIsNameValid] = useState(false);
  const [isBirthdayValid, setIsBirthdayValid] = useState(false);

  const monthRef = useRef<TextInput>(null);

  const onSubmitPress = useCallback(() => {
    BottomSheet.open({
      namespace: 'account',
      type: 'SelfExclusion',
      titleNS: 'responsibleGaming',
      titleKey: 'selfExclusionTitleBottomSheet',
      data: {
        value: selfExcludeTime,
      },
    });
  }, [selfExcludeTime]);

  return (
    <Screen>
      <KeyboardShift showsVerticalScrollIndicator={false} style={{ flex: 1 }}>
        <Box gap="space-800">
          <Text
            variant="body-m-semi"
            locNS="responsibleGaming"
            locKey="selfExclusionVerifyDescription"
            color="darkSurfacePrimary"
          />

          <Box gap="space-200">
            <Text
              variant="h5"
              locNS="responsibleGaming"
              locKey="yourName"
              color="darkSurfacePrimary"
            />

            <NameInput
              setIsNameValid={setIsNameValid}
              onLastFieldSubmit={() => monthRef.current?.focus()}
            />
          </Box>

          <Box gap="space-200">
            <Text
              variant="h5"
              locNS="responsibleGaming"
              locKey="yourBirthday"
              color="darkSurfacePrimary"
            />

            <BirthdayInput
              setIsBirthdayValid={setIsBirthdayValid}
              refMonthInput={monthRef}
            />
          </Box>

          <Button
            variant="primary"
            onPress={onSubmitPress}
            locNS="common"
            locKey="submit"
            disabled={!isNameValid || !isBirthdayValid}
          />
        </Box>
      </KeyboardShift>
    </Screen>
  );
}

export default memo(SelfExclusionVerifyScreen);
